import { UrlConstants } from "../url.constants";
export class ApiRequiredDocumentsChecklistConstants {
    static URL = UrlConstants.API_V2 + "RequiredDocumentsChecklist";
    static FUNCTION_MARK_AS_NOT_COMPLETE = "MarkRDCAsNotComplete";
    static FUNCTION_MARK_AS_COMPLETED = "MarkRDCAsCompleted";
}
